import PropTypes from 'prop-types';
import Image from 'components/UI/Image/Image';
import { asPerformanceDate } from 'utils/date-formatter';
import parse from 'html-react-parser';

export const UpsellEventInformation = (props) => {
  const {
    Title,
    Imagepath,
    Performance: { Description, DateTime, Venue },
    UpsellType,
    SitecoreDescription,
  } = props;

  return (
    <div className="panel-body panel-has-img" data-testid="upsells-event-info">
      <h3 className="title">{Title}</h3>

      <Image
        alt={Description}
        desktopImage={Imagepath}
        extendClass="img-framed img-responsive"
        extendTestId="upsells-thumb"
      />

      {(UpsellType === 'Performance' || UpsellType === 'Lunchbox') && (
        <h4 className="subtitle" data-testid="event-venue">
          Venue: {Venue}
        </h4>
      )}

      <p data-testid="event-date">{asPerformanceDate(DateTime)}</p>
      <p data-testid="event-desc">{parse(SitecoreDescription)}</p>
    </div>
  );
};

UpsellEventInformation.propTypes = {
  Title: PropTypes.string,
  Imagepath: PropTypes.string,
  Performance: PropTypes.object,
  UpsellType: PropTypes.string,
  SitecoreDescription: PropTypes.string,
};
